import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import VueTranslate from 'vue-translate-plugin'

if (typeof window.uaCode !== 'undefined') {
    Vue.use(VueAnalytics, {
      id: window.uaCode
    })
}

Vue.use(VueTranslate);

// window.locales   = {
//     non_Danish: {
//         'Anmeldelser': 'Anmeldelser',
//         'Annuller': 'Avbryt',
//         'Bekræfte': 'Bekrefte',
//         'Er du ikke bruger': 'Hvis du ikke er bruker',
//         'Garanteret tavshedspligt': 'Garantert konfidensialitet',
//         'Har du lige haft en samtale med': 'Har du nettopp hatt en samtale med',
//         'Indtast din 4-cifret PIN-kode': 'Skriv inn din 4-sifrede PIN-kode',
//         'Indtast din anmeldelse beskrivelse': 'Skriv inn anmeldelsen din',
//         'Indtast dit telefonnummer': 'Skriv inn telefonnummeret ditt',
//         'JA': 'JA',
//         'Jeg er optaget lige nu.': 'Jeg er opptatt akkurat nå.',
//         'Klik på "Ring mig op"': 'Klikk på "Ring meg"',
//         'Konsultenten ringer dig nu op': 'Konsulenten vil nå',
//         'Ledig': 'Gratis',
//         'Logget ud': 'Logget ut',
//         'Læs mere...': 'Les mer...',
//         'Nej': 'Nei',
//         'Om': 'Om',
//         'Opkaldet gik ikke igennem.': 'Samtalen gikk ikke gjennom.',
//         'Opret bruger': 'Opprett bruker',
//         'Optaget': 'Okkupert',
//         'Prøv venligst igen om et kort øjeblik': 'Vennligst prøv igjen snart',
//         'Samlet bedømmelse': 'Samlet vurdering',
//         'VENT VENLIGST': 'VENNLIGST VENT',
//         'VI BEKLAGER MEGET': 'VI ER VELDIG MYE',
//         'Ved klik på "Ring mig op" ringes du': 'Ved å klikke på "Ring meg" du',
//         'Vil du have besked på sms når jeg er ledig igen?': 'Ønsker du å bli varslet via SMS når jeg er ledig igjen?',
//         'Vurder din erfaring med': 'Vurder din erfaring',
//         'Vælg konsulent': 'Velg konsulent',
//         'fra': 'fra',
//         'her': 'her',
//         'indenfor 10-15 sek': 'innen 10-15 sek',
//         'indenfor de næste 3 dage efter din samtale': 'innen de neste 3 dagene etter samtalen din',
//         'konsulenten': 'konsulent',
//         'kr/minut': 'nok/minutt',
//         'minimum': 'minimum',
//         'minutter': 'minutter',
//         'og nåede du ikke at give en anmeldelse? Kan du give en anmeldelse': 'og ga du ikke en anmeldelse? Kan du gi en anmeldelse',
//         'op indenfor 10-15 sekunder af': 'er kalt innen 10-15 sekunder av',
//         'opret dig her': 'lag deg selv her',
//         'tlf.': 'tlf.'
//     },
//     da_DK: {
//     }
// }
// window.locale  = 'non_Danish';
var translations = {};
if (typeof window.locales !== 'undefined') {
    translations = window.locales;
}
Vue.locales(translations);

if(typeof window.production == 'undefined' && typeof window.serverUrl == 'undefined' && typeof window.k24CosultantData == 'undefined' && typeof window.K24ConsultantsOthers == 'undefined'){
    window.serverUrl = 'https://staging.klarsyn24.dk/wp-json/k24/v1/';
    window.k24CustomerData = {
                                id:99,
                                phones:[
                                            {
                                                label: '+302109940690',
                                                value: '+302109940690'
                                            },
                                            {
                                                label: '+306974055197',
                                                value: '+306974055197'
                                            }
                                        ]
                             };
    window.k24CosultantData = [

            {
                name:"Carin",
                skills: [{name:"Afdødekontakt"}, {name:"Clairvoyance"}, {name:"Kanalisering"}, {name:"Klarsyn"}],
                bio:"TEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bioTEST bio",
                description:"TEST description, TEST description TEST description TEST description TEST description",
                availability:'away',
                ClairvoyantId:3,
                imgUrl:'https://staging.klarsyn24.dk/wp-content/uploads/2018/09/carin-1.jpg',
                pricePerMinute: 21.65,
                minimumDuration: 10,
                ratings: 4,
                audio: null,
                video: null,
                ratingsNum: 214,
                next_available : 'Tuesday - 09:00',
                reviews: [
                        {
                            "overall":4,
                            "username":"Andreas",
                            "content":"Here goes a test text for the review\r\n\r\nSomething long to be displayed on frontend.\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.\u00a0\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.",
                        },
                        {
                            "overall":4,
                            "username":"Andreas",
                            "content":"Here goes a test text for the review\r\n\r\nSomething long to be displayed on frontend.\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.\u00a0\u00a0Something long to be displayed on frontend. Something long to be displayed on frontend.",
                        }
                ]
            }
    ];
}


new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})

Vue.mixin({
  methods: {
    googleAnalyticsEvent: function (event) {
        if (this.$ga) {
            this.$ga.event(event);
        }
        else {
            console.log('Google analytics not set, so no data sent');
        }
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js